import {pathByShapeMiddleware} from 'components/customer/BTM/store/middleware/pathByShapeMiddleware';
import {dimensionUpdateMiddleware} from 'components/customer/BTM/store/middleware/dimensionUpdateMiddleware';
import {materialSetMiddleware} from 'components/customer/BTM/store/middleware/materialSelectMiddleware';

export const btmMiddleware = [
    pathByShapeMiddleware,
    dimensionUpdateMiddleware,
    materialSetMiddleware,
];
